/* eslint-disable */
import React, { createContext, useEffect, useState } from "react";
import styled, { withTheme } from 'styled-components';
import { ifProp, theme, withProp } from 'styled-tools';
//import InPlaySection from "./in-play-desktop/index";
import PopularSection from "./popular-desktop";
import Tabs from '../common/Tab';
import InPlayLiveTv from './inplay-livetv';
//import BetSlip from "../BetSlip/index";
import BetSlip_myBet_tab from "../BetSlip/betslip-mybet_tabs";
// import { color } from '../../sass-files/variable';
import MarketList from "../eu-content/MarketList";
import FavoriteList from "../eu-content/FavoriteMarket"
import OpenMarketList from "../eu-content/OpenMarketList";

import { MatchListContext } from '../../store/MatchListContext';
import { OrderListContext } from '../../store/OrderListContext';
import cookieUtil from "src/util/cookieUtil";
import { ECookieName } from "src/util/utilModel";
import BgDark from '../../images/iMAGE1_iexch.jpg';
import Bg from '../../images/iMAGE1_iexch.png';
import config from "src/config/config";
// import Icon, { IconWrapper } from '../common/PNGIcon';
// import NewsEvent from "../eu-content/news-event";
import { useQuery } from "@apollo/client";
import { GET_EVENTS } from "src/graphql/events";
import util from "src/util/util";
// import { GET_EVENT_NEWS_CLIENT } from "src/graphql/agentMember";
import NewsEvent from "src/pages/eu-content/news-event";
// import Marquee from "react-fast-marquee";
// import Speaker from '../../images/speaker-red_blue.png';
import Intl from '../common/Intl';
// import Switch from "../eu-content/Switch";
// import { getGTMId } from "src/util/gtmUtil";
import { withAppContext } from "src/store/initAppContext";
// import Sidebar, { GameEventSubMenu } from '../eu-content/sidebar/sidebar';
// import SideNav, { Toggle, Nav, NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';
// import { ButtonWrapper } from "../eu-content/sidebar/MatchButton";
// import { CategoryNameWrapper } from "../eu-content/sidebar/sidebar";
// import { CategoryIcon } from "../eu-content/sidebar/sidebar";
// import { MainButtonWrapper } from "../eu-content/sidebar/FoldButton";
// import { FootNoteWrapper } from "../common/sidebar/styles/commonSidebarCompnents";
// import { GameEventName } from "../eu-content/sidebar/sidebar";
// import MenuSidebar from "./menu-sidebar";
import BonusPopup from "../BonusPopup";
import { Circle } from "../eu-content/Switch";
import Search from 'src/components/search/index';
// import { Player } from "@lottiefiles/react-lottie-player";
// import { getWhatsAppInfo } from "src/config/api";
import { Link, useLocation } from "react-router-dom";
import { Player } from "@lottiefiles/react-lottie-player";

import LeaderBoard from "src/components/leaderboard";
import IPLTABConfig from "src/util/iplTab";

//import PopularMarketList from "../eu-content/PopularMarketList";
//import InnerGameDetails from '../eu-content/inner-game-details/game-details';
// const { homeExchangeBgColor } = color
// const tabName = ['In-play', 'Favorites', 'My Markets']

let Inplay = <Intl langKey="TABLE@IN_PLAY" />;
let Favorites = <Intl langKey="MENU@FAVORITES" />;
let MyMarkets = <Intl langKey="MENU@MARKET" />

let tabName = [Inplay, Favorites, MyMarkets] // Changing cost to let because of IPL TAB



const HomeExchange = (props) => {
    const { app: { brandId }, memberId = 0, theme: { config } }: any = props;
   
    const { showSeoFooterInsidePages, showSEOfooterForYolo, showAPISEOData } = config
    const location = useLocation();
    const getLastqueryString =  location.pathname.split("/").pop();


    // let location = useLocation()

    let { pathname } = location;
   
    const [isShowInPlay, SetIsShowInPlay] = useState(true);
    const [popularNewsEvent, setPopularNewsEvent] = useState([]);
    const [results, setResults] = useState([]);
    const [categoryId, setCategoryId] = useState(0);
    const [results_popular, setResults_popular] = useState([]);
    const [isDarkTheme, setIsDarkTheme] = useState(false);
    const [backgroundImage, setBackgroundImage] = useState(Bg);
    const [catId, setCatId] = useState(0)
    const [animationImage, setAnimationImage] = useState("");

    //needs to pass competition id later for IPL tab changes in query input so storing it 
    let queryInput:any =  { categoryId: catId, isInplay: true, singleFancy: true, isFavorite: true }

    //CHANGES FOR IPL TAB SEO
    const {showIPLTab, iplUrl, iplCompetitionId} = IPLTABConfig;
    const isIPLTab = pathname.includes(iplUrl) && showIPLTab;
   
    if(isIPLTab) {
        tabName = [Inplay, Favorites];
        queryInput =  { categoryId: catId, competitionId: iplCompetitionId, isInplay: true, singleFancy: false, isFavorite: true }
    }

    const { loading, error, data } = useQuery(GET_EVENTS, {
        variables: { input: { ...queryInput } }
    });

    useEffect(() => {
        const themeS = JSON.parse(localStorage.getItem("isDarkTheme")) === null ? false : JSON.parse(localStorage.getItem("isDarkTheme"));
        setIsDarkTheme(themeS)
        setBackgroundImage(cookieUtil.get(ECookieName.COOKIE_THEME) === "Dark" ? BgDark : Bg)

        if(pathname.includes('/betting-exchange/volleyball')){
            setCatId(12);
        } else if (pathname.includes('/betting-exchange/cricket')){
            setCatId(4);
        } else if (pathname.includes(iplUrl)){
            setCatId(4);
        } else if (pathname.includes('/betting-exchange/tennis')) {
            setCatId(2);
        } else if (pathname.includes('/betting-exchange/football')) {
            setCatId(1);
        } else if (pathname.includes('/specialMarket')) {
            setCatId(100);
        }else {
            setCatId(0);
        }
    }, [pathname])

    useEffect(() => {
       
        const marketList = util.getValue(data, ['markets', 'list'], []);
        const result = []
        const filtermarketList = marketList.map((market) => result.push(Number(market.eventId)))
        const categoryId = marketList.length > 0 && marketList[0].categoryName || ''
        const isCurrentShowInPlay = marketList.length > 0;
        isCurrentShowInPlay && categoryId !== categoryId &&

            SetIsShowInPlay(isCurrentShowInPlay),
            setResults(result),
            setCategoryId(categoryId)
    }, [])

    const toggleTheme = () => {
        let themeArray = ['Dark', 'Light', 'Default']
        let selectedIndex = !isDarkTheme
        let themedata = themeArray[selectedIndex ? 0 : 1]
        setIsDarkTheme(!isDarkTheme)
        localStorage.setItem("isDarkTheme", JSON.stringify(!isDarkTheme))
        cookieUtil.set(ECookieName.COOKIE_THEME, themeArray[selectedIndex ? 0 : 1])
        setBackgroundImage(cookieUtil.get(ECookieName.COOKIE_THEME) === "Dark" ? BgDark : Bg)

        const { setState } = props.app || {};
        if (typeof setState === 'function') {
            let _reqData = {
                theme: (cookieUtil.get(ECookieName.COOKIE_THEME) === "Dark" ? "Dark" : "Light")
            }
            setState(_reqData)
        }
    }

    // const ElectionPopup = () => {
    //     const [showElement, setShowElement] = useState(true);

    //     useEffect(() => {
    //         const interval = setInterval(() => {
    //             setShowElement(prev => !prev);
    //         }, 5000);

    //         return () => clearInterval(interval);
    //     }, []);

    //     return (
    //         <>
    //             {showElement && (
    //                 <ElectionPopupWrapper>
    //                     <Link to="/specialMarket">
    //                         <Player
    //                             autoplay
    //                             loop
    //                             controls
    //                             src={animationImage}
    //                             style={{ width: '151px', height: '219px' }}
    //                         />
    //                     </Link>
    //                 </ElectionPopupWrapper>
    //             )}
    //         </>
    //     );
    // };


    useEffect(() => {
        switch(brandId) {
           case 31:
            setAnimationImage("https://pixel.raksahb.com/popupjsons/electionPopupYolo.json")
            break;
           case 32: 
            setAnimationImage("https://pixel.raksahb.com/popupjsons/electionPopupYolo.json")
            break;
           case 33:
            setAnimationImage("https://pixel.raksahb.com/popupjsons/electionPopupBaazi.json")
            break;
           case 34:
            setAnimationImage("https://pixel.raksahb.com/popupjsons/electionPopupBaazi.json")
            break;
           case 39:
            setAnimationImage("https://pixel.raksahb.com/popupjsons/electionPopupFomo7.json")
            break;
           case 40:
            setAnimationImage("https://pixel.raksahb.com/popupjsons/electionPopupFomo7.json")
            break;
        }  
     
    }, [])

    return (
        <>
            <SideBarWrapperMain>
                {/* <SidebarWrapper>
                <SideNav onSelect={(selected) => {}}>
                    <SideNav.Toggle />
                    <SideNav.Nav defaultSelected="home">
                        <NavItem eventKey="home">
                            <Sidebar/>
                        </NavItem>
                    </SideNav.Nav>
                </SideNav>
           </SidebarWrapper> */}
                <SidebarWrap theme={props.app.theme}>

                    {/* <MenuSidebar/> */}

                </SidebarWrap>
               { results && results.length>0 && <NewsEvent data={results} />}
                <AppWrapper id="ExchageContainer" className="app_wrapper" theme={props.app.theme} customStyle={props.theme.image}>
                    <MatchListContext memberId={memberId}> 
                        <OrderListContext>
                            <HomepageExchangeWrapper>
                                <InPlayHeader>
                                    <InPlayLiveTv />
                                </InPlayHeader>
                                <ExchangeWrapp>
                                    <Tabs
                                        tabs={tabName}
                                        isTabsHidden={false}
                                        minWidthInContent={'initial'}
                                        render={(index) => {
                                            return (
                                                <>
                                                    {tabName[index] === Inplay  && <> <MarketList />  <PopularSection /> </>}
                                                    {/* Changes for IPL TAB */}
                                                     {/* {tabName[index] === Inplay && isIPLTab && <> <MarketList />  </>}  */}
                                                    {tabName[index] === Favorites && <FavoriteList />}
                                                    {tabName[index] === MyMarkets && <OpenMarketList />}
                                                </>
                                            );
                                        }} />
                                </ExchangeWrapp>
                                <BetSlipWrapper>
                                    <ToggleButton>
                                        <Search />

                                        {/* <span><Intl langKey="TITLE@LIGHTTHEME"/></span> */}
                                        {/* <div className="switchdiv">
                                        <Switch currentActiveState={isDarkTheme}
                                            handleClick={toggleTheme}
                                            id={getGTMId(`ExchageContainer`)} />
                                    </div> */}
                                        {/* <span><Intl langKey="TITLE@DARKTHEME"/></span> */}
                                    </ToggleButton>
                                    <BetSlipTittle><BetSlipTab><Intl langKey="TITLE@BetSlipTittle" /></BetSlipTab></BetSlipTittle>
                                    <BetSlip_myBet_tab />
                                </BetSlipWrapper>
                                <BonusPopup />
                                {/* <ElectionPopup /> */}
                            </HomepageExchangeWrapper>
                        </OrderListContext>
                    </MatchListContext>

                    {/* ADDING LEADER BOARD */}
                    {pathname && pathname === "/" && <LeaderBoard />}
    
                </AppWrapper>
            </SideBarWrapperMain>
        </>
    )
}
export default withTheme(withAppContext(HomeExchange));

export const BetSlipTittle = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    letter-spacing: 0.04em;
    text-transform: capitalize;
    color: ${theme('palette.InPlayTableBetSlipTittleColor')};
    border-bottom: ${theme('palette.InPlayTableBetSlipTittleBorder')};
    padding: ${theme('palette.InPlayTableBetSlipTittlePadding')};
    margin-bottom: 17px;
    font-size: 14px;
    font-weight: bold;
    background: ${theme('palette.InPlayTableBetSlipTittleBg')};
`;

const BetSlipTab = styled.div`
    letter-spacing: 0.04em;
    text-transform: capitalize;
    font-size: 14px;
    font-weight: bold;
    color: ${theme('palette.InPlayTableBetSlipTittleColor')};
    padding: ${theme('palette.InPlayTableBetSlipTittleTabPadding')};
    border-radius: ${theme('palette.TabDefaultBorderRadius')};
    background: ${theme('palette.TabActiveBackgroundColor')};
`;

const SidebarWrap = styled.div`
    display: flex;
`;

const SideBarWrapperMain = styled.div`
  display: flex;
  position: relative;
`;

export const AppWrapper: any = styled.div`
    display: flex;
    width: 100%;
    height: auto;
    background: transparent;
    flex-direction:column
`;

export const HomepageExchangeWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 5px 0px 20px;
    flex-wrap: wrap;
    position: relative;
    // overflow: hidden;
    /* background-image: url{bg} */
`;

const InPlayHeader = styled.div`
    // width: 73%;
    margin-top: 5px;
    width: 250px;
    position: absolute;
    left: 0;
    top: 0;
    padding: 10px;
    margin-left: 10px;
    /* background: ${theme('palette.secondary-background-color-linear-new')}; */
    background: ${theme('palette.InPlayHeaderBgNew')};
    /* background: #6778E3; */

    :after {
        content: "";
        width: 45px;
        height: 101%;
        /* background: ${theme('palette.secondary-background-color-linear-new-after')}; */
        background: ${theme('palette.InPlayHeaderBgNewAfter')};
        position: absolute;
        top: 0;
        right: -15px;
        transform: skew(18deg);
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }
`;

const BetSlipWrapper = styled.div`
    width: 25%;
    position: sticky;
    top: 32px;
    overflow-y: scroll;
    min-height:calc(20vh);
    max-height: calc(100vh - 2em);
    right: 0;
    overflow: hidden auto;
    scroll-behavior: smooth;
   
   ::-webkit-scrollbar {
        display: none;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
`;

export const ToggleButton = styled.div`
    color: #fff;
    width: 70%;
    font-size: 15px;
    font-weight: 600;
    /* margin-top: 5px; */
    /* width: 250px; */
    display: flex;
    flex-direction: row;
    /* justify-content: space-evenly; */
    position: absolute;
    right: 0;
    top: 0px;
    padding-left: 10px;
    /* background: ${theme('palette.secondary-background-color-new')}; */

    .switchdiv{
        padding-left: 5px;
        /* padding-left: 0px;
        padding-right: 10px;
        border-radius: 99em;
        border: 1px solid #FFFF;
        width: 46px; */

        ${Circle} {
            display: none;
        }

        button {
            width: 140px;
            height: 48px;
            border-radius: 0;
            border: none;
            margin: 0;

            &::before {
                content: 'LIGHT';
                width: 50%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 0;
                right: unset;
                bottom: unset;
                border-radius: 0;
                pointer-events: none;
                background: #fff;
                left: 0;
                color: #000;
                font-size: 12px;
                font-weight: bold;

            }

            &::after {
                content: 'DARK';
                width: 50%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 0;
                right: 0;
                bottom: unset;
                left: unset;
                border-radius: 0;
                pointer-events: none;
                background: #6778E3;
                font-size: 12px;
                color: #fff;
                font-weight: bold;
            }
        }
    }   

    /* :after {
        content: "";
        width: 45px;
        height: 100%;
        background: #234294;
        position: absolute;
        top: 0;
        right: 345px;
        transform: skew(340deg);
    } */
    
`;

export const ExchangeWrapp = styled.div`
    width: 74%;
    padding: 40px 20px 20px 10px;
`;

const ElectionPopupWrapper = styled.div`
    position: fixed;
    top: 120px;
    /* bottom: 0; */
    right: 0;
    z-index: 99;
`